/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import {inviteLinksGet, InviteLinksGetParams} from "../fn/invite-link/invite-links-get";
import {InviteLinkModel} from "../models/invite-link-model";
import {inviteLinksPut, InviteLinksPutParams} from "../fn/invite-link/invite-links-put";
import {inviteLinksPost, InviteLinksPostParams} from "../fn/invite-link/invite-links-post";
import {PaginatedList} from "../models/paginator/paginated-list";

@Injectable({ providedIn: 'root' })
export class InviteLinkService extends BaseService {
    constructor(config: ApiConfiguration, http: HttpClient) {
        super(config, http);
    }

    /**
     * Gets all invite links for a particular questionnaire
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `inviteLinksGet()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    inviteLinksGet$Response(headers: HttpHeaders, params: InviteLinksGetParams, context?: HttpContext): Observable<StrictHttpResponse<PaginatedList<InviteLinkModel>>> {
        return inviteLinksGet(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Gets all invite links for a particular questionnaire
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `inviteLinksGet$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`
     */
    inviteLinksGet(headers: HttpHeaders, params: InviteLinksGetParams, context?: HttpContext): Observable<PaginatedList<InviteLinkModel>> {
        return this.inviteLinksGet$Response(headers, params, context).pipe(
            map((r: StrictHttpResponse<PaginatedList<InviteLinkModel>>): PaginatedList<InviteLinkModel> => r.body)
        );
    }

    /**
     * Updates an existing invite link
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `inviteLinksPut()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    inviteLinksPut$Response(params: InviteLinksPutParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<InviteLinkModel>> {
        return inviteLinksPut(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Updates an existing invite link
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `inviteLinksPut$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    inviteLinksPut(params: InviteLinksPutParams, headers: HttpHeaders, context?: HttpContext): Observable<InviteLinkModel> {
        return this.inviteLinksPut$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<InviteLinkModel>): InviteLinkModel => r.body)
        );
    }

    /**
     * Creates a new invite link
     *
     *
     *
     * This method provides access to the full `HttpResponse`, allowing access to response headers.
     * To access only the response body, use `inviteLinksPost()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    inviteLinksPost$Response(params: InviteLinksPostParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<InviteLinkModel>> {
        return inviteLinksPost(this.http, this.rootUrl, params, headers, context);
    }

    /**
     * Creates a new invite link
     *
     *
     *
     * This method provides access only to the response body.
     * To access the full response (for headers, for example), `inviteLinksPost$Response()` instead.
     *
     * This method sends `application/json` and handles request body of type `application/json`.
     */
    inviteLinksPost(params: InviteLinksPostParams, headers: HttpHeaders, context?: HttpContext): Observable<InviteLinkModel> {
        return this.inviteLinksPost$Response(params, headers, context).pipe(
            map((r: StrictHttpResponse<InviteLinkModel>): InviteLinkModel => r.body)
        );
    }
}
